import { Project } from './../../../core/store/projects/project.model';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ah-assets-import',
    templateUrl: './assets-import.component.html',
    styleUrls: ['./assets-import.component.scss'],
    standalone: false
})
export class AssetsImportComponent implements OnInit {
    projectList$: Observable<Project[]>;
    constructor() { }

    ngOnInit() {

    }



}
